import React from 'react';

import { css } from '@emotion/react';
import type { HStackProps } from '@rtkwlf/fenrir-react';
import { HStack } from '@rtkwlf/fenrir-react';

export const PageToolbarRoot: React.FC<
  React.PropsWithChildren<HStackProps>
> = ({ children, ...rest }) => {
  const childrenCount = React.Children.count(children);

  return (
    <HStack
      width="full"
      justifyContent={childrenCount === 2 ? 'space-between' : 'flex-end'}
      css={css({
        '@media print': {
          display: 'none',
        },
      })}
      {...rest}
    >
      {children}
    </HStack>
  );
};
